const data = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About",
    url: "#about",
    
  },
  {
    title: "Roadmap",
    url: "#roadmap",
  },
  {
    title: "FAQ",
    url: "#faq",
  },
  {
    title: "How to Mint",
    url: "#howToMint",
  },
  {
    title: "Audit",
    url: "https://www.safetin.com/audit/alpha-octopus",
    target: "_blank",
    extra: "New"
  },
  // {
  //   title: "Terms of Service",
  //   url: "#",
  // },
];

export default data;
